const FacetActionTypes = {
  ADD_CATEGORY_1_FACET_VALUE: 'ADD_CATEGORY_1_FACET_VALUE',
  REMOVE_CATEGORY_1_FACET_VALUE: 'REMOVE_CATEGORY_1_FACET_VALUE',
  ADD_CATEGORY_3_FACET_VALUE: 'ADD_CATEGORY_3_FACET_VALUE',
  REMOVE_CATEGORY_3_FACET_VALUE: 'REMOVE_CATEGORY_3_FACET_VALUE'
};

export default FacetActionTypes;
